const parseNumber = (value: string) => {
  const cleaned = value.trim().replace(/[^0-9.,]/g, '')

  if (!cleaned) return undefined

  const commas = (cleaned.match(/,/g) ?? []).length
  const dots = (cleaned.match(/\./g) ?? []).length

  let normalized = cleaned

  if (commas > 1) {
    normalized = cleaned.replace(/,/g, '')
  } else if (dots > 1) {
    normalized = cleaned.replace(/\./g, '').replace(',', '.')
  } else if (commas === 1 && dots === 1) {
    const commaIdx = cleaned.indexOf(',')
    const dotIdx = cleaned.indexOf('.')

    if (dotIdx < commaIdx) {
      normalized = cleaned.replace('.', '').replace(',', '.')
    } else {
      normalized = cleaned.replace(',', '')
    }
  } else if (commas === 1 && dots === 0) {
    const afterComma = cleaned.split(',')[1] ?? ''
    normalized = afterComma.length === 3 ? cleaned.replace(',', '') : cleaned.replace(',', '.')
  }

  const result = parseFloat(normalized)
  return isNaN(result) ? undefined : result
}

export default parseNumber
